import yup, { cardNameValidator, imageValidator, integerPositiveValidator } from '~/utils/validators.yup';

export const schema = (nullable = false) =>
    yup.object({
        name: cardNameValidator(),
        image: imageValidator(nullable),
        icon: imageValidator(nullable),
        traitAmount: integerPositiveValidator,
        statPoint: integerPositiveValidator,
    });
